import React, { useEffect, useRef, useState } from "react";
import TopNavigation from "./TopNavigation";
import Sidebar from "./Sidebar";
import {
  Outlet,
  unstable_HistoryRouter,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSession from "../../hooks/useSession";
import { FaChevronLeft, FaChevronUp } from "react-icons/fa";
import useDetectOutsideClick from "../../hooks/useDetectOutsideClick";

function Layout({ toggleDarkMode, darkMode }) {
  const [isSidenavClosed, setIsSidenavClosed] = useState(true);
  const navigate = useNavigate();
  let location = useLocation();
  const [user] = useSession();
  const [scrolled, setScrolled] = useState(false);
  const containerRef = useRef(null);
  const sideBarRef = useRef(null);
  useDetectOutsideClick(sideBarRef, closeHamburger);

  useEffect(() => {
    setIsSidenavClosed(true);
  }, [location]);

  // menu toggle
  function toggleHamburger() {
    setIsSidenavClosed((old) => !old);
  }
  function closeHamburger() {
    setIsSidenavClosed(true);
  }

  // LOGOUT handler - clear from session and navigate to login page
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  // show back to top button on scroll
  useEffect(() => {
    const changeScrolledState = () => {
      if (containerRef.current.scrollTop >= 300) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    containerRef.current.addEventListener("scroll", changeScrolledState);
  }, []);

  function scrollToTop() {
    containerRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  return (
    <main className="flex flex-row relative">
      <Sidebar
        isSidenavClosed={isSidenavClosed}
        darkMode={!darkMode}
        handleLogout={handleLogout}
        sideBarRef={sideBarRef}
      />
      <div
        className="w-full max-h-screen overflow-y-auto pt-4 pb-4 md:pb-0 px-4 cxl:pl-0 bg-[#1D2235] dark:bg-darkModeBg"
        ref={containerRef}
      >
        <div className="w-full overflow-hidden">
          <TopNavigation
            toggleHamburger={toggleHamburger}
            toggleDarkMode={toggleDarkMode}
            handleLogout={handleLogout}
            darkMode={!darkMode}
            user={user}
          />
          {/* Body section */}
          <div className="bg-gray-200 dark:border dark:border-[#333] dark:border-t-0 dark:bg-darkModeBg dark:text-darkWhite transition-colors duration-100 min-h-full overflow-hidden ">
            <div className="h-auto min-h-screen p-2">
              <Outlet />
              <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              {/* --------------{bottom buttons}-------------- */}
              {location?.pathname?.split("/")?.length > 2 && (
                <>
                  {/* scroll To Top */}
                  <button
                    onClick={scrollToTop}
                    className={`${
                      scrolled
                        ? "translate-y-0 opacity-100"
                        : "translate-y-[500%]"
                    } flex bg-secondary bg-opacity-70 hover:bg-opacity-100 h-10 w-10 rounded-lg capitalize text-base md:text-base items-center justify-center text-gray-50 shadow-lg hover:shadow-none dark:text-gray-50 transition-all duration-300 fixed bottom-20 right-12 focus:pointer-events-auto cursor-pointer`}
                  >
                    <FaChevronUp />
                  </button>

                  <hr
                    className={`${
                      scrolled ? "max-w-[2.5rem]" : "max-w-[0]"
                    } w-full h-px border-secondary dark:border-secondary/50 transition-all duration-300 fixed bottom-[4.5rem] right-12`}
                  />

                  {/* back to previous page with next router */}
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="flex bg-secondary bg-opacity-70 hover:bg-opacity-100 h-10 w-10 rounded-lg capitalize text-base md:text-base items-center justify-center shadow-lg hover:shadow-none text-gray-50 dark:text-gray-50  transition-all duration-300 fixed bottom-[1.5rem] right-12"
                  >
                    <FaChevronLeft />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Layout;
